import { render } from "./InboxPanel.vue?vue&type=template&id=033e7320&ts=true"
import script from "./InboxPanel.vue?vue&type=script&lang=ts"
export * from "./InboxPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__